// extracted by mini-css-extract-plugin
export default {"SortIcon":"styles_SortIcon__1qWeo","desc":"styles_desc__7pCRl","visible":"styles_visible__8CgEW"};